import Vue from 'vue'
import Vuex from 'vuex'
import Api from '../../fetch'
// import Types from './mutation-types'

Vue.use(Vuex)

const transitionCtrl = !/dt_from=app/.test(location.href)

const state = {
  isLoading: false,
  direction: transitionCtrl ? 'forward' : '',
  bindingPhoneType: false,
  app: '',
  dtFrom: null,
  paymentPromptStatus: false,
  version: '',  // 当前手机上版本
  fnVersion: '',  // 当前功能版本
  collectData: {
    page_url: location.href,
    enter_time: null, // 进入时间
    leave_time: null, // 离开时间
    adviser_id: -1, // 投顾id
    course_id: -1, // 课程id
    event: '',
    event_name: ''
  },
  uid: '',
  ticket: '',
  userInfo: {},
  guideShow: 0,
}

export default new Vuex.Store({
  state,
  mutations: { // 必须同步执行
    UPDATE_LOADING (state, payload) {
      state.isLoading = payload.isLoading
    },
    UPDATE_DIRECTION (state, payload) {
      if (!transitionCtrl) {
        return
      }
      state.direction = payload.direction
    },
    // 设置用户数据
    SET_USER_INFO (state, data) {
      state.userInfo = data
      window.localStorage.setItem('user', JSON.stringify(state.userInfo));
    },
    // 设置用户uid
    SET_USER_ID (state, data) {
      state.uid = data
    },
    // 设置用户ticketd
    SET_USER_TICKETD (state, data) {
      state.ticket = data
    },
    // app版本赋值
    SET_APP_VERSION (state, data) {
      // 赋值
      state.version = data.version
      state.fnVersion = data.fnVersion
    },
    // 打开绑定手机弹窗状态
    OPEN_BINDING_PHONE_MODEL (state) {
      state.bindingPhoneType = true
    },
    // 关闭绑定手机弹窗状态
    COLSE_BINDING_PHONE_MODEL (state) {
      state.bindingPhoneType = false
    },
    // 设置页面来源是否app
    SET_DT_FROM (state, data) {
      state.dtFrom = data
    },
    // 判断页面是ios还是安卓
    SET_APP (state, data) {
      state.app = data
    },
    // 埋点接后台接口
    COLLECT (state, eventData) {
      let data = {}
      switch (eventData.type) {
        // 进入页面记录时间
        case 'enter':
          state.collectData.enter_time = Date.now()
          state.collectData.event = eventData.event
          state.collectData.event_name = eventData.eventName
          break
        // 离开页面记录时间并提交后台
        case 'leave':
          state.collectData.leave_time = Date.now()
          state.collectData.event = eventData.event
          state.collectData.event_name = eventData.eventName
          data = {
            page_url: location.href,
            enter_time: state.collectData.enter_time, // 进入时间
            leave_time: state.collectData.leave_time, // 离开时间
            event: state.collectData.event,
            event_name: state.collectData.eventName,
            business_source: 5
          }
          if (eventData.app === 'ios' || eventData.app === 'android') {
            Api.app.appCollect(data)
          } else {
            Api.common.collect(data)
          }
          break
        // 选择投顾id提交后台
        case 'sendAdviserId':
          state.collectData.adviser_id = eventData.adviserId
          state.collectData.event = eventData.event
          state.collectData.event_name = eventData.eventName
          data = {
            page_url: state.collectData.page_url,
            adviser_id: state.collectData.adviser_id,
            event: state.collectData.event,
            event_name: state.collectData.eventName,
            business_source: 5
          }
          if (eventData.app === 'ios' || eventData.app === 'android') {
            Api.app.appCollect(data)
          } else if (eventData.app === '') {
            Api.common.collect(data)
          }
          break
        // 选择课程id提交后台
        case 'sendCourseId':
          state.collectData.course_id = eventData.courseId
          state.collectData.event = eventData.event
          state.collectData.event_name = eventData.eventName
          data = {
            page_url: state.collectData.page_url,
            course_id: state.collectData.course_id,
            event: state.collectData.event,
            event_name: state.collectData.eventName,
            business_source: 5
          }
          if (eventData.app === 'ios' || eventData.app === 'android') {
            Api.app.appCollect(data)
          } else if (eventData.app === '') {
            Api.common.collect(data)
          }
          break
      }
    },
    // 埋点接友盟接口
    CZC_PUSH (state, data) {
      /* eslint-disable */
      console.log(data);
      // window._czc.push(data)
    },
    // 支付提示
    PAYMENT_PROMPT_STATUS (state, data) {
      state.paymentPromptStatus = data.type
    },
    // 记录返回引导弹框
    UPDATE_BACK (state, data) {
      state.guideShow = data;
    },
  },
  actions: { // 支持异步执行
    COLLECT (context, param) {
      setTimeout(() => {
        context.commit('COLLECT', param.eventData)
      }, 0);
    }
  },
  getters: { // 类似compute
    //
  }
})



// WEBPACK FOOTER //
// ./src/plugins/store/index.js